import { colors } from "../../../data/colors";
import { useTranslation } from "react-i18next";
import { itemTypes } from "../../../data/types/itemTypes";

export default function MenuItem({
  data,
  width,
  onClick,
}: {
  data: itemTypes;
  width: number;
  onClick: () => void;
}) {
  const { t } = useTranslation();
  const { type, Icon } = data;
  return (
    <div className="itemContainer" style={{ width }}>
      <div
        className="menuBox"
        onClick={onClick}
        style={{
          backgroundColor: colors[type as keyof typeof colors],
        }}
      >
        {typeof type === "string" && t(`p.${type}`)}
        <div style={{ position: "absolute", bottom: 10, right: 10 }}>
          <Icon style={{ fontSize: 90 }} />
        </div>
      </div>
    </div>
  );
}
